export default {
  communicateCenter_my_circle: 'My circle',
  communicateCenter_more_circle: 'More',
  communicateCenter_first_more_circle: 'Go to follow your first circle',
  communicateCenter_no_dynamic: 'No moments yet',
  communicateCenter_no_nickname: 'No nickname',
  communicateCenter_from_circle: 'From circle',
  communicateCenter_total_pics: '{Totalplural, =0 {no images} =1 {one image} other {# image}} in total',
  communicateCenter_reply: 'post/posts',
  communicateCenter_comment: '{commentCount, =0 {no comments.} =1 {one comment.} other {# comments.}}',
  communicateCenter_collect: '{collectCount, =0 {no favorites.} =1 {one favorite.} other {# favorites.}}',
  communicateCenter_like: '{likeCount, =0 {no likes.} =1 {one like.} other {# likes.}}',
}
